import {AfterContentInit, Component, EventEmitter, OnDestroy, TemplateRef, ViewChild} from '@angular/core';
import {
  ApDynComponentComponent
}                                                                                     from '../../../ap-dyncomponent/ap-dyncomponent.component';
import {BehaviorSubject, combineLatest, Observable, of, Subscription}                 from 'rxjs';
import {
  PpWizardStates
}                                                                                     from '../planning-wizard/pp-planning-wizard.types';
import {
  ApDynformsConfigFieldset
}                                                                                     from '../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  IPpProductAvailableCrops,
  IPpProductSelectedDetails,
  IPpProductWizardDetailsData,
  IPpProductWizardOverviewData,
  IPpProductWizardProvider
}                                                                                     from './pp-product-wizard.types';
import {
  PpProductWizardDetailsProvider
}                                                                                     from './configs/pp-product-wizard-details.provider';
import {
  PpProductWizardOverviewProvider
}                                                                                     from './configs/pp-product-wizard-overview.provider';
import {
  ApUtilService
}                                                                                     from '../../../ap-utils/service/ap-util.service';
import {
  FormStore
}                                                                                     from '../../../stores/layout/form.store';
import {
  CropTypeStore
}                                                                                     from '../../../stores/base-data/crop.types.store';
import {
  ApTranslationService
}                                                                                     from '../../../ap-utils/service/ap-translation.service';
import {filter, map}                                                                  from 'rxjs/operators';
import {
  ApDynGridsComponent
}                                                                                     from '../../../ap-dyngrids/ap-dyngrids.component';
import {
  PlantProtectionProductStore
}                                                                                     from '../../../stores/base-data/plantprotection.product.store';
import {ApGuidUtil}                                                                   from '../../../ap-utils';
import {
  CountryStore
}                                                                                     from '../../../stores/common/country.store';
import {
  ApRoleTypeService
}                                                                                     from '../../../services/common/ap-role-type.service';
import {
  LoginStore
}                                                                                     from '../../../stores/login/login.store';
import {
  ApDateService
}                                                                                     from '../../../ap-core/services/ap-date-service';
import {
  UnitsStore
}                                                                                     from '../../../stores/common/units.store';
import {
  WorkTypesStore
}                                                                                     from '../../../stores/base-data/worrktypes.store';
import {
  EffectiveRangesStore
}                                                                                     from '../../../stores/common/effective-ranges.store';
import IPlantProtectionProductWriteable = Data.BaseData.IPlantProtectionProductWriteable;
import IPlantProtectionProductDetailsWriteable = Data.BaseData.IPlantProtectionProductDetailsWriteable;

/**
 * Main PP-product wizard component
 */
@Component({
  selector: 'pp-product-wizard',
  template: `
    <ap-dyncomponent [caption]="caption$ | async"
                     [headerIcon]="'ap-fungidetect-icon'"
                     [fieldSets]="fieldSets$ | async"
                     [canCreate]="false"
                     [loading$]="saving$"
                     [formValidators]="wizardDetailsProvider?.formValidators">
      <div class="ap-form-actions" dynforms.action>
        <div apResponsive
             [sizeMd]="'25-100'"
             [style.text-align]="'left'">
          <button kendoButton
                  [id]="'button_prev'"
                  [type]="'button'"
                  [class]="'k-button k-primary button-important'"
                  (click)="handleStateChangeAction.emit(activeWizardStep === wizardSteps.Details ? wizardSteps.Cancel : wizardSteps.Details)">
            <ap-responsive-text [key]="activeWizardStep === wizardSteps.Details ? 'Global__Cancel' : 'Global__Back'"></ap-responsive-text>
          </button>
        </div>
        <div apResponsive
             [sizeMd]="'50-100'"
             [style.text-align]="'center'">
          <ap-breadcrumbs-steper [columns]="breadCrumbsColumns"
                                 [selected]="activeWizardStep === wizardSteps.Details ? 0 : 1">
          </ap-breadcrumbs-steper>
        </div>
        <div apResponsive
             [sizeMd]="'25-100'"
             [style.text-align]="'right'">
          <button kendoButton
                  [id]="'button_next'"
                  [disabled]="(!wizardDetailsProvider.isValid() && activeWizardStep === wizardSteps.Details) || (selectedDetailsItems$.asObservable() | async)?.length <= 0"
                  [type]="'button'"
                  [class]="'k-button k-primary button-important'"
                  (click)="handleStateChangeAction.emit(activeWizardStep === wizardSteps.Details ? wizardSteps.Overview : wizardSteps.Save)">
            <ap-responsive-text [key]="activeWizardStep === wizardSteps.Details ? 'Global_Next_With_Arrow' : 'Global__Save'"></ap-responsive-text>
          </button>
        </div>
      </div>
    </ap-dyncomponent>
    <ng-template #ppProductSelectedDetailsTemplate>
      <ap-dyngrids
        id="SelectedDetails"
        class="pp-selected-details ap-grid-max-height ap-form-element-border ap-grid-bright-header"
        [class]="(selectedDetailsItems$.asObservable() | async)?.length <= 0 ? 'ap-form-element-error-border' : ''"
        [ngStyle]="{'height': (activeWizardProvider$ | async)?.getSelectedDetailsGridHeight()}"
        [columns]="wizardDetailsProvider.productDetailsColumns$ | async"
        [items]="selectedDetailsItems$.asObservable() | async"
        [pageable]="false"
        [groupable]="false"
        [checkboxDisabled]="true"
        (selectionChange)="wizardDetailsProvider.onDetailsSelectionChange($event)"
        [selectable]="{checkboxOnly: false, mode: 'single'}">
      </ap-dyngrids>
      <div class="ap-error" *ngIf="(selectedDetailsItems$.asObservable() | async)?.length <= 0">
        <ap-responsive-text [key]="'Settings__Msg_Vali_Value_Required'"></ap-responsive-text>
      </div>
    </ng-template>
    <ng-template #ppProductAvailableCropsTemplate>
      <ap-dyngrids class="pp-available-crops ap-grid-max-height ap-form-element-border, ap-grid-bright-header"
                   id="AvailableCrops"
                   [columns]="wizardDetailsProvider.availableCropsColumns"
                   [items]="availableCropsItems$ | async"
                   [componentReference$]="ppProductAvailableCropsGrid$"
                   [pageable]="false"
                   [groupable]="false"
                   [selectable]="{checkboxOnly: false, mode: 'multiple'}">
      </ap-dyngrids>
      <div class="ap-note" style="padding-top:2px; padding-bottom:10px">
        <ap-responsive-text [text]="getSelectedCropsNote()"></ap-responsive-text>
      </div>
    </ng-template>
  `,
  styles: [
    '.pp-selected-details { display: block; }',
    '.pp-available-crops { height: 200px; display: block; margin-top: 10px}'
  ],
  providers: [
    PpProductWizardDetailsProvider,
    PpProductWizardOverviewProvider
  ]
})
export class PpProductWizardComponent implements AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) public dynComponent: ApDynComponentComponent;
  @ViewChild('ppProductSelectedDetailsTemplate', {static: true}) public ppProductSelectedDetailsTemplate: TemplateRef<any>;
  @ViewChild('ppProductAvailableCropsTemplate', {static: true}) public ppProductAvailableCropsTemplate: TemplateRef<any>;
  // @ViewChild does not work in case the child-component is embedded within ng-template.
  // Therefore, we need to get the grid reference in our own way
  public ppProductAvailableCropsGrid$: BehaviorSubject<ApDynGridsComponent> = new BehaviorSubject<ApDynGridsComponent>(undefined);

  private _subscriptions: Subscription[] = [];
  private _stateModel: { [oldState: string]: { [newState: string]: () => void } } = {};
  public activeWizardStep: PpWizardStates = PpWizardStates.Details;
  public wizardSteps = PpWizardStates;
  public activeWizardProvider$ = new BehaviorSubject<IPpProductWizardProvider>(undefined);
  public caption$ = new BehaviorSubject<string>('Nutrients__SelectFieldsTitle');
  public fieldSets$ = new BehaviorSubject<ApDynformsConfigFieldset[]>([]);
  public selectedDetailsItems$: BehaviorSubject<IPpProductSelectedDetails[]> = new BehaviorSubject<IPpProductSelectedDetails[]>([]);
  public availableCropsItems$: Observable<IPpProductAvailableCrops[]> = of([]);
  public handleStateChangeAction: EventEmitter<any>;
  public saving$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public detailsData: IPpProductWizardDetailsData;
  public overviewData: IPpProductWizardOverviewData;
  public breadCrumbsColumns = [
    PpWizardStates.Details,
    PpWizardStates.Overview
  ];

  constructor(public wizardDetailsProvider: PpProductWizardDetailsProvider,
              private wizardOverviewProvider: PpProductWizardOverviewProvider,
              private plantProtectionProductStore: PlantProtectionProductStore,
              private cropTypeStore: CropTypeStore,
              private translationService: ApTranslationService,
              private countryStore: CountryStore,
              private loginStore: LoginStore,
              private dateService: ApDateService,
              private unitsStore: UnitsStore,
              private workTypesStore: WorkTypesStore,
              private effectiveRangesStore: EffectiveRangesStore,
              private formStore: FormStore) {
    this.handleStateChangeAction = ApUtilService.createEventEmitter(this.handleStateChange.bind(this), this._subscriptions);
    /*
     * Setup of plant protection wizard state machine...
     */
    this._stateModel[PpWizardStates.Details] = {};
    this._stateModel[PpWizardStates.Overview] = {};
    this._stateModel[PpWizardStates.Save] = {};
    // Definition of actions when state changes: [oldState][newState] => (action) executed
    this._stateModel[PpWizardStates.Details][PpWizardStates.Overview] = this.initOverview.bind(this); // user switches from details to overview-tab
    this._stateModel[PpWizardStates.Overview][PpWizardStates.Save] = this.initSave.bind(this); // user clicks export in overview
    this._stateModel[PpWizardStates.Overview][PpWizardStates.Details] = this.initDetails.bind(this); // user goes back to details from overview
    this._stateModel[PpWizardStates.Details][PpWizardStates.Cancel] = this.initLeave.bind(this); // leaving the wizard
    this._stateModel[PpWizardStates.Save][PpWizardStates.Details] = this.initDetails.bind(this); // after failed save user goes back to details
    this._stateModel[PpWizardStates.Save][PpWizardStates.Save] = this.initSave.bind(this); // save retry by user

    this.availableCropsItems$ = this.cropTypeStore.Listen(s => s.data).pipe(
      filter(d => !!d),
      map(cropTypes => cropTypes.filter(c => c.Selected)
        .map<IPpProductAvailableCrops>(c => {
          return {
            Id: c.Id,
            CropTypeName: this.translationService.translate(c.Description)
          };
        })
      )
    );
    /**
     * Handle saving indicator and close for if saved successfully
     */
    this._subscriptions.push(
      combineLatest([
        this.plantProtectionProductStore.Listen(x => x.saving),
        this.plantProtectionProductStore.Listen(x => x.saved)
      ]).subscribe(([saving, saved]) => {
        if (!this.saving$?.value && saving) {
          this.saving$.next(true);
          return;
        }
        if (this.saving$?.value) {
          if (saved) {
            setTimeout(() => this.formStore.closeForm(), 1);
          }
          this.saving$.next(false);
        }
      }));
  }

  public ngAfterContentInit(): void {
    this.wizardDetailsProvider.init(
      this.caption$,
      this.fieldSets$,
      this.dynComponent.dynForm,
      this.selectedDetailsItems$,
      this.ppProductAvailableCropsGrid$,
      this.ppProductSelectedDetailsTemplate,
      this.ppProductAvailableCropsTemplate);
    this.wizardOverviewProvider.init(
      this.caption$,
      this.fieldSets$,
      this.ppProductSelectedDetailsTemplate);

    this.dynComponent.dynForm.initialized.subscribe(() => {
      // Handle subscriptions in one place and forward them to the corresponding
      // wizard provider which is currently in charge of the action
      this._subscriptions.push(this.dynComponent.dynForm.formValueChanges.subscribe(valuesChangesArgs => {
        if (this.activeWizardStep !== PpWizardStates.Details || this.dynComponent.dynForm.form.pristine ||
          (!this.dynComponent.dynForm.form.dirty && !this.dynComponent.dynForm.form.touched)) {
          return;
        }
        this.wizardDetailsProvider.onFormValueChanges(valuesChangesArgs);
      }));
      this.initDetails();
    });
  }

  /**
   * Handles the state transitions between the wizard steps
   * and performs the corresponding actions defined in the wizard stateMachine/Model
   * @param newState the new wizard step. The user might have navigated back or forward
   * @private
   */
  private handleStateChange(newState: PpWizardStates): void {
    const oldState = this.activeWizardStep;
    this.activeWizardStep = newState;
    if (this._stateModel[oldState][newState]) {
      this._stateModel[oldState][newState]();
    }
  }

  /**
   * Handles whatever needs to happen when the wizard switches to Details
   * @private
   */
  private initDetails(): void {
    this.activeWizardProvider$?.next(this.wizardDetailsProvider);
    if (!this.detailsData) {
      this.detailsData = this.wizardDetailsProvider.buildDefaultDetails();
    }

    this.buildUi(this.wizardDetailsProvider);
    setTimeout(() =>
      this.dynComponent.dynForm.form.patchValue(this.detailsData), 0);
    // trigger initial validations. Do not trigger validations if user
    setTimeout(() => this.dynComponent.dynForm.markAsTouched(), 0);
  }

  /**
   * Handles whatever needs to happen when the wizard switches to Overview
   * @private
   */
  private initOverview(): void {
    this.wizardDetailsProvider.leave();
    this.activeWizardProvider$?.next(this.wizardOverviewProvider);
    this.detailsData = this.dynComponent.dynForm.form.getRawValue() as IPpProductWizardDetailsData;
    this.overviewData = this.wizardOverviewProvider.buildOverviewItem(this.detailsData);
    this.buildUi(this.wizardOverviewProvider);
    setTimeout(() =>
      this.dynComponent.dynForm.form.patchValue(this.overviewData), 0);
  }

  /**
   * Generic function to generate/build UI depending on the current wizard state.
   * @private
   */
  private buildUi(wizardProvider: IPpProductWizardProvider): void {
    if (!wizardProvider) {
      return;
    }
    wizardProvider.updateCaption();
    wizardProvider.updateFieldSets(this.overviewData);
  }

  /**
   * Handles whatever needs to happen when save is clicked
   * @private
   */
  private initSave(): void {
    if (!this.detailsData || this.selectedDetailsItems$?.value?.length === 0) {
      return;
    }
    const productId = ApGuidUtil.generateNewGuid();
    const country = ApRoleTypeService.hasAgriconRole(this.loginStore.User) && this.detailsData?.IsCountryWide && this.detailsData.Country ?
      this.countryStore.Countries.FirstOrDefault(c => c?.Id === this.detailsData?.Country)
      : this.loginStore.SelectedFarm?.Country;
    const ppProductDetails: IPlantProtectionProductDetailsWriteable[] = [];
    const selectedProductDetails = this.selectedDetailsItems$.value;
    for (const productDetail of selectedProductDetails) {
      if (!productDetail || productDetail?.EffectiveRangeIds?.length <= 0 || productDetail.CropTypeIds?.length <= 0) {
        continue;
      }
      for (const effectiveRangeId of productDetail.EffectiveRangeIds) {
        for (const cropTypeId of productDetail.CropTypeIds) {
          ppProductDetails.push({
            Id: ApGuidUtil.generateNewGuid(),
            ProductId: productId,
            AmountMax: productDetail.MaxRate,
            EcMax: productDetail.GrowStageMax,
            EcMin: productDetail.GrowStageMin,
            EffectiveRange: this.effectiveRangesStore.getEffectiveRangeById(effectiveRangeId),
            EppoCrop: this.cropTypeStore.getDefaultCroptype(cropTypeId)?.Eppocode,
            EppoHarmfulOrganism: null,
            Unit: this.unitsStore.getUnitWithUnit(this.detailsData?.Unit),
            WorkType: this.workTypesStore.WorkTypes?.FirstOrDefault(w => w.Id === this.detailsData.WorkType),
            FarmId: this.detailsData.IsCountryWide ? -1 : this.loginStore.SelectedFarmId,
            Indicator: productDetail.Indicator,
            GrowthStageDefined: true,
            ChangedAt: null,
            ChangedBy: null,
            CreatedAt: null,
            CreatedBy: null,
            DeletedAt: null,
            DeletedBy: null,
            Version: 0
          });
        }
      }
    }
    const ppProduct: IPlantProtectionProductWriteable = {
      Id: productId,
      ProductName: this.detailsData?.ProductName,
      Note: this.detailsData?.Note,
      PermissionStart: this.dateService.getDateNoon(this.detailsData?.PermissionStart),
      PermissionEnd: this.dateService.getDateNoon(this.detailsData?.PermissionEnd),
      UseByDate: this.dateService.getDateNoon(this.detailsData?.UseByDate),
      Country: country,
      ExternalProductId: productId?.replace('-', ''),
      ProductDetails: ppProductDetails,
      FarmId: this.detailsData.IsCountryWide ? -1 : this.loginStore.SelectedFarmId,
      ChangedAt: null,
      ChangedBy: null,
      CreatedAt: null,
      CreatedBy: null,
      DeletedAt: null,
      DeletedBy: null,
      Version: 0
    };
    this.plantProtectionProductStore.createNewProduct(ppProduct);
  }

  /**
   * Handles whatever needs to happen when leaving the wizard
   * @private
   */
  private initLeave(): void {
    setTimeout(() => this.formStore.closeForm(), 1);
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
    this.wizardDetailsProvider.onDestroy();
    this.wizardOverviewProvider.onDestroy();
    this.wizardDetailsProvider = undefined;
    this.wizardOverviewProvider = undefined;
  }

  public getSelectedCropsNote(): string {
    return `${this.ppProductAvailableCropsGrid$?.value?.gridPaging?.selectedKeys?.length?.toString()}
    ${this.translationService.translate('Global__Selected')}`;
  }
}
